import { createReducerContext } from '../../../../utils/create-reducer-context';
import { HomeState, HomeReducer, ACTION_TYPES } from './home-reducer';

const initialState: HomeState = {
    sections: [],
    loading: false,
    sectionDrawer: { open: false },
    itemDrawer: { open: false },
};

const { Provider: HomeProvider, useStateContext: useHomeState, useDispatchContext: useHomeDispatch } = createReducerContext('Home', HomeReducer, initialState);

export { HomeProvider, useHomeState, useHomeDispatch, ACTION_TYPES };
